import api from './api';
// 获得所有单位列表
export function viewMembers(params) {
  return api.post('/org/list', params, true, false).then(res => res);
}

// 获得具体单位的详细信息
export function viewOneMembers(params) {
  return api.post('/org/oneOrg', params, true, false).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/frontApi/frontMembers.js